const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    API_ERROR: true,
    API_SUCCESS: true,
    API_RESET: true,
});
